import { FC, useContext } from 'react';
import { useWxWork } from '@cloud/wxwork-workbench';
import ScreenContext from '@/contexts/screen';
import Button from '@/components/Button';
import Tooltip from '@/components/Tooltip';
import { smallSizeWidth } from '@/constants';
import { openInBrowser } from '@/utils';
import { ReactComponent as IOpenInBrowser } from '@/assets/icons/browser.svg';
import styles from './index.less';

const HelpTips: FC<{}> = () => {
  const { width: screenWidth } = useContext(ScreenContext);
  const signature = useWxWork();

  if (screenWidth < smallSizeWidth) {
    return null;
  }

  return (
    <div className={styles.helpTips}>
      <Button type='link' className={styles.helpButton}
        onClick={() => window.open('https://docs.qq.com/doc/DVUpKZXplSnNkaEJu')}
      >快速加粉攻略</Button>
      <Tooltip title='用浏览器打开此页面'>
        <Button
          type='text'
          className={styles.openInBrowserButton}
          onClick={() => openInBrowser(signature)}
        >
          <IOpenInBrowser />
        </Button>
      </Tooltip>
    </div>
  )
}

export default HelpTips;
